<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            <button style="margin-right: 25px; font-size: 15px" onclick="history.back()" class="btn btn-primary btn-lg">Voltar</button>
            Editar lote
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/leiloes">Leilões</a></li>
            <li class="breadcrumb-item">#{{ leilao.id }}</li>
            <li class="breadcrumb-item"><a :href="'/admin/leilao/' + leilao.id + '/lotes'">Lotes</a></li>
            <li class="breadcrumb-item">#{{ lote.lote_numero }}</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de Lote</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- SITUAÇÃO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_modo_generico">Situação do lote</label>

                <select class="custom-select rounded-0" id="lote_situacao" v-model="formData.lote_situacao" style="text-transform: uppercase">
                  <option value=""></option>
                  <option value="desocupado">Desocupado</option>
                  <option value="ocupado">Ocupado</option>
                </select>
              </div>
            </div>

            <!-- LABEL -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="lote_label">Label alternativa box home</label>
                <input
                  class="form-control"
                  id="lote_label"
                  v-model="formData.lote_label"
                  @blur="upper('lote_label')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- LABEL COR -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="lote_label_color">Cor label box home</label>
                <input
                  class="form-control"
                  id="lote_label_color"
                  v-model="formData.lote_label_color"
                  @blur="upper('lote_label_color')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- LOTE TIPO -->
            <div class="col-sm-3">
              <div class="form-group">
                <label for="leilao_modo_generico">Tipo do lote</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_tipo"
                  v-model="formData.lote_tipo"
                  @change="changeTipoLote"
                  style="text-transform: uppercase"
                >
                  <option value=""></option>
                  <option value="imovel">Imóvel</option>
                  <option value="movel">Móvel</option>
                  <option value="sucata">Sucata</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_tipo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- LANCE PARCELADO -->
            <div :class="formData.lote_permitir_parcelamento == 1 ? 'col-sm-12' : 'col-sm-6'">
              <div class="form-group">
                <label for="lote_permitir_parcelamento">Permitir lance parcelado</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_permitir_parcelamento"
                  v-model="formData.lote_permitir_parcelamento"
                  @change="changeParcelamento"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_permitir_parcelamento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FORM PARCELAMENTO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="lote_permitir_form_parcelamento">Habilitar form de parcelamento</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_permitir_form_parcelamento"
                  v-model="formData.lote_permitir_form_parcelamento"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_permitir_form_parcelamento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
            -->

            <!-- FORM PARCELAMENTO 
            <div class="col-sm-6">
              <div class="form-group">
                <label for="lote_negar_pf">Bloquear lance PF</label>

                <select class="custom-select rounded-0" id="lote_negar_pf" v-model="formData.lote_negar_pf" style="text-transform: uppercase">
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_negar_pf.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
            -->

            <!-- INFORMAÇÕES GERAIS -->
            <div class="col-sm-12" v-if="formData.lote_permitir_parcelamento == 1">
              <div class="form-group">
                <label for="lote_texto_parcelamento">Texto Form. Parcelado</label>

                <Editor v-model="formData.lote_texto_parcelamento" editorStyle="height: 200px" style="background-color: white" />
              </div>
            </div>

            <!-- REGRA PARCELAMENTO -->
            <div class="col-sm-12" v-if="formData.lote_permitir_parcelamento == 1">
              <div class="form-group">
                <label for="lote_regra_parcelamento">Regra de parcelamento</label>
                <input
                  class="form-control"
                  id="lote_regra_parcelamento"
                  placeholder=""
                  v-model="formData.lote_regra_parcelamento"
                  @blur="upper('lote_regra_parcelamento')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- LOTE ENTRADA -->
            <div class="col-sm-4" v-if="formData.lote_permitir_parcelamento == 1">
              <div class="form-group">
                <label for="lote_pct_entrada">% Entrada</label>
                <input class="form-control" id="lote_pct_entrada" placeholder="" v-model="formData.lote_pct_entrada" type="number" />

                <span style="color: red" v-for="error in v$.lote_pct_entrada.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- MAX PARCELAS -->
            <div class="col-sm-4" v-if="formData.lote_permitir_parcelamento == 1">
              <div class="form-group">
                <label for="lote_max_parcelas">Máximo de parcelas</label>
                <input class="form-control" id="lote_max_parcelas" placeholder="" v-model="formData.lote_max_parcelas" type="number" />

                <span style="color: red" v-for="error in v$.lote_max_parcelas.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INDICE CORREÇÃO -->
            <div class="col-sm-4" v-if="formData.lote_permitir_parcelamento == 1">
              <div class="form-group">
                <label for="lote_indice_correcao">Índice de correção</label>
                <input
                  class="form-control"
                  id="lote_indice_correcao"
                  placeholder=""
                  v-model="formData.lote_indice_correcao"
                  @blur="upper('lote_indice_correcao')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.lote_indice_correcao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FORM PROPOSTA -->
            <div
              v-if="formData.leilao.leilao_1_modalidade == 'venda'"
              :class="formData.leilao.leilao_1_modalidade == 'venda' ? 'col-sm-6' : 'col-sm-6'"
            >
              <div class="form-group">
                <label for="lote_permitir_form_proposta">Habilitar form de proposta/venda direta</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_permitir_form_proposta"
                  v-model="formData.lote_permitir_form_proposta"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_permitir_form_proposta.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- FORM PROPOSTA INFERIOR-->
            <div class="col-sm-6" v-if="formData.leilao.leilao_1_modalidade == 'venda'">
              <div class="form-group">
                <label for="lote_permitir_form_proposta_inferior">Permitir valor inferior</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_permitir_form_proposta_inferior"
                  v-model="formData.lote_permitir_form_proposta_inferior"
                  style="text-transform: uppercase"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_permitir_form_proposta_inferior.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- COMISSÃO -->
            <div :class="formData.lote_tipo == 'movel' || formData.lote_sucata_restricao == 1 ? 'col-sm-3' : 'col-sm-6'">
              <div class="form-group">
                <label for="lote_comissao">Comissão</label>
                <input
                  class="form-control"
                  id="lote_comissao"
                  placeholder=""
                  v-model="formData.lote_comissao"
                  type="number"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.lote_comissao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- COMISSÃO TIPO -->
            <div :class="formData.lote_tipo == 'movel' || formData.lote_sucata_restricao == 1 ? 'col-sm-3' : 'col-sm-3'">
              <div class="form-group">
                <label for="lote_comissao_tipo">Calcular comissão sobre</label>

                <select
                  disabled="true"
                  class="custom-select rounded-0"
                  id="lote_comissao_tipo"
                  v-model="formData.lote_comissao_tipo"
                  style="text-transform: uppercase"
                >
                  <option value="avaliacao">Avaliação</option>
                  <option value="lance">Lance</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_comissao_tipo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- SUCATA/RESTRIÇÃO DETRAN -->
            <div
              v-if="formData.lote_tipo == 'sucata'"
              :class="formData.lote_tipo == 'sucata' || formData.lote_sucata_restricao == 1 ? 'col-sm-3' : 'col-sm-3'"
            >
              <div class="form-group">
                <label for="lote_sucata_restricao">Sucata/Restrição Detran</label>

                <select
                  class="custom-select rounded-0"
                  id="lote_sucata_restricao"
                  v-model="formData.lote_sucata_restricao"
                  style="text-transform: uppercase"
                  @change="alterarIcms"
                >
                  <option :value="0">Não</option>
                  <option :value="1">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.lote_sucata_restricao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ICMS -->
            <div class="col-sm-3" v-if="formData.lote_tipo == 'movel' || formData.lote_sucata_restricao == 1">
              <div class="form-group">
                <label for="lote_sucata_restricao">ICMS</label>

                <input class="form-control" id="lote_icms" placeholder="" v-model="formData.lote_icms" type="number" />

                <span style="color: red" v-for="error in v$.lote_icms.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INDICE CORREÇÃO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="lote_incrementos">Incrementos</label>
                <input class="form-control" id="lote_incrementos" placeholder="" v-model="formData.lote_incrementos" />

                <span style="color: red" v-for="error in v$.lote_incrementos.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('500')">500</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('1000')" style="margin-left: 5px">1000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('1500')" style="margin-left: 5px">1500</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('2000')" style="margin-left: 5px">2000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('3000')" style="margin-left: 5px">3000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('4000')" style="margin-left: 5px">4000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('5000')" style="margin-left: 5px">5000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('6000')" style="margin-left: 5px">6000</button>
                <button type="submit" class="btn btn-info btn-sm" @click="addIncrementos('9000')" style="margin-left: 5px">9000</button>
              </div>
            </div>

            <!-- ID'S PRIORIDADE MAIOR-->
            <div class="col-sm-4">
              <div class="form-group">
                <label>Clientes IDS Lance Preferencial (Prioridade maior)</label>
                <input class="form-control" v-model="formData.lotes_ids_cliente_lance_pref_prio_maior" @keyup="formatar" type="text" />
              </div>
            </div>

            <!-- ID'S PRIORIDADE MEDIA-->
            <div class="col-sm-4">
              <div class="form-group">
                <label>Clientes IDS Lance Preferencial (Prioridade média)</label>
                <input class="form-control" v-model="formData.lotes_ids_cliente_lance_pref_prio_media" @keyup="formatar" type="text" />
              </div>
            </div>

            <!-- ID'S PRIORIDADE MEDIA-->
            <div class="col-sm-4">
              <div class="form-group">
                <label>Clientes IDS Lance Preferencial (Prioridade menor)</label>
                <input class="form-control" v-model="formData.lotes_ids_cliente_lance_pref_prio_menor" @keyup="formatar" type="text" />
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="endereco_estado">UF</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado_id"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade_id" style="text-transform: uppercase">
                  <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>

            <!-- PROCESSO -->
            <div class="col-sm-4">
              <div class="form-group" id="form_group_processo">
                <label for="processo">
                  Processo
                  <span style="margin-left: 15px; color: red" v-if="lote.processo_id != leilao.processo_id">* Processo divergente do leilão</span>
                </label>

                <!-- <input class="form-control" placeholder="" v-model="formData.processo_id" type="text" /> -->
                <input
                  :style="lote.processo_id != leilao.processo_id ? 'color: red' : ''"
                  disabled
                  class="form-control"
                  placeholder=""
                  v-model="formData.processo_numero"
                />

                <!--
                <div class="input-group">
                  <v-autocomplete
                    id="processo"
                    variant="outlined"
                    :items="processos"
                    item-title="processo_numero"
                    return-object
                    v-model="formData.processo"
                    density="compact"
                  ></v-autocomplete>
                </div>

                <span v-if="formData.leilao_tipo == 'judicial'" style="color: red" v-for="error in v$.processo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
                -->
              </div>
            </div>

            <!-- CATEGORIA -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="endereco_cidade">Categoria</label>

                <div class="input-group">
                  <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.categoria_id" style="text-transform: uppercase">
                    <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">
                      {{ categoria.nome }}
                    </option>
                  </select>

                  <div class="input-group-append">
                    <button
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#categoria-modal"
                      @click="show_categoria_modal = true"
                    >
                      <i class="fas fa-plus"></i>
                      Adicionar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- TITULO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="lote_titulo">Título</label>
                <input
                  class="form-control"
                  id="lote_titulo"
                  placeholder=""
                  v-model="formData.lote_titulo"
                  type="text"
                  @blur="upper('lote_titulo')"
                  style="text-transform: uppercase"
                />

                <span style="color: red" v-for="error in v$.lote_titulo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DESCRICAO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="lote_descricao">Descrição</label>

                <Editor v-model="formData.lote_descricao" editorStyle="height: 200px" style="background-color: white" />

                <span style="color: red" v-for="error in v$.lote_descricao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- INFORMAÇÕES ADICIONAIS -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="lote_info_adicional">Informações adicionais</label>

                <Editor v-model="formData.lote_info_adicional" editorStyle="height: 200px" style="background-color: white" />
              </div>
            </div>

            <!-- VALOR AVALIAÇÃO -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="lote_avaliacao">Valor da avaliação</label>
                <input class="form-control" id="lote_avaliacao" placeholder="0.00" v-model="formData.lote_avaliacao" />

                <button type="submit" class="btn btn-info btn-sm" data-toggle="modal" data-target="#calcular-modal" @click="zerarNovosValores()">
                  Calcular valores
                </button>

                <span style="color: red" v-for="error in v$.lote_avaliacao.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VALOR 1 -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="lote_valor_1">Valor 1</label>
                <input disabled class="form-control" id="lote_valor_1" placeholder="0.00" :value="toCurrency(formData.lote_valor_1)" />
                <span style="color: red" v-for="error in v$.lote_valor_1.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VALOR 2 -->
            <div class="col-sm-4" v-if="formData.leilao.leilao_num_pracas >= 2">
              <div class="form-group">
                <label for="lote_valor_2">Valor 2</label>
                <input disabled class="form-control" id="lote_valor_2" placeholder="0.00" :value="toCurrency(formData.lote_valor_2)" />

                <span style="color: red" v-for="error in v$.lote_valor_2.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VALOR 3 -->
            <div class="col-sm-4" v-if="formData.leilao.leilao_num_pracas >= 3">
              <div class="form-group">
                <label for="lote_valor_3">Valor 3</label>
                <input disabled class="form-control" id="lote_valor_3" placeholder="0.00" :value="toCurrency(formData.lote_valor_3)" />

                <span style="color: red" v-for="error in v$.lote_valor_3.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VALOR 4 -->
            <div class="col-sm-4" v-if="formData.leilao.leilao_num_pracas >= 4">
              <div class="form-group">
                <label for="lote_valor_4">Valor 4</label>
                <input disabled class="form-control" id="lote_valor_4" placeholder="0.00" :value="toCurrency(formData.lote_valor_4)" />

                <span style="color: red" v-for="error in v$.lote_valor_4.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- CALCULAR MODAL -->
        <div
          class="modal fade"
          id="calcular-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          style="margin-top: 30px"
        >
          <form @submit.prevent>
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4>Calcular valores</h4>
                  <br />
                  <div class="row">
                    <div class="col-md-12">
                      <div class="card card-primary">
                        <div class="card-body">
                          <div class="row">
                            <!-- AVALIAÇÃO -->
                            <div class="col-sm-12">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Valor da avaliação</label>
                                <input
                                  class="form-control"
                                  id="nome_completo"
                                  placeholder="1000"
                                  :value="toCurrency(formData.lote_avaliacao)"
                                  readonly="true"
                                />
                              </div>
                            </div>

                            <!-- VALOR 1 -->
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="exampleInputEmail1">% Valor 1</label>
                                <input
                                  class="form-control"
                                  id="nome_completo"
                                  placeholder="1000"
                                  v-model="percentual_valor_1"
                                  type="number"
                                  step="0.01"
                                />
                                <strong v-if="formData.lote_valor_1" style="font-size: 13px">
                                  Valor atual R$ {{ toCurrency(formData.lote_valor_1) }}
                                </strong>
                                <!-- <strong style="font-size: 13px">- Valor novo: R$ {{ label_valor_1 }}</strong> -->
                              </div>
                            </div>

                            <!-- VALOR 1 -->
                            <div class="col-sm-6">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Valor 1</label>
                                <input class="form-control" v-model="label_valor_1" @keyup="alterarValor" @blur="formatarValor" />
                                <strong v-if="lote_valor_1" style="font-size: 13px">Novo R$ {{ toCurrency(lote_valor_1) }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 2 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 2">
                              <div class="form-group">
                                <label for="exampleInputEmail1">% Valor 2</label>
                                <input
                                  class="form-control"
                                  id="nome_completo"
                                  placeholder="1000"
                                  v-model="percentual_valor_2"
                                  type="number"
                                  step="0.01"
                                />
                                <strong v-if="formData.lote_valor_2" style="font-size: 13px">Valor atual R$ {{ formData.lote_valor_2 }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 2 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 2">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Valor 2</label>
                                <input class="form-control" v-model="label_valor_2" @keyup="alterarValor" @blur="formatarValor" />
                                <strong v-if="lote_valor_2" style="font-size: 13px">Novo R$ {{ toCurrency(lote_valor_2) }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 3 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 3">
                              <div class="form-group">
                                <label for="exampleInputEmail1">% Valor 3</label>
                                <input
                                  class="form-control"
                                  id="nome_completo"
                                  placeholder="1000"
                                  v-model="percentual_valor_3"
                                  type="number"
                                  step="0.01"
                                />
                                <strong v-if="formData.lote_valor_3" style="font-size: 13px">Valor atual R$ {{ formData.lote_valor_3 }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 3 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 3">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Valor 3</label>
                                <input class="form-control" v-model="label_valor_3" @keyup="alterarValor" @blur="formatarValor" />
                                <strong v-if="lote_valor_3" style="font-size: 13px">Novo R$ {{ toCurrency(lote_valor_3) }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 4 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 4">
                              <div class="form-group">
                                <label for="exampleInputEmail1">% Valor 4</label>
                                <input
                                  class="form-control"
                                  id="nome_completo"
                                  placeholder="1000"
                                  v-model="percentual_valor_4"
                                  type="number"
                                  step="0.01"
                                />
                                <strong v-if="formData.lote_valor_4" style="font-size: 13px">Valor atual R$ {{ formData.lote_valor_4 }}</strong>
                              </div>
                            </div>

                            <!-- VALOR 4 -->
                            <div class="col-sm-6" v-if="leilao.leilao_num_pracas >= 4">
                              <div class="form-group">
                                <label for="exampleInputEmail1">Valor 4</label>
                                <input class="form-control" v-model="label_valor_4" @keyup="alterarValor" @blur="formatarValor" />
                                <strong v-if="lote_valor_4" style="font-size: 13px">Novo R$ {{ toCurrency(lote_valor_4) }}</strong>
                              </div>
                            </div>
                            <br />
                            <button type="submit" class="btn btn-primary" @click="calcular()">Calcular</button>

                            <button
                              type="submit"
                              class="btn btn-danger"
                              @click="importar()"
                              style="margin-left: 15px"
                              data-toggle="modal"
                              data-target="#calcular-modal"
                            >
                              Transferir
                            </button>

                            <button type="submit" class="btn btn-info" style="margin-left: 15px" data-toggle="modal" data-target="#calcular-modal">
                              Voltar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div
          class="modal fade"
          id="categoria-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          v-if="show_categoria_modal"
        >
          <form @submit.prevent>
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4>Nova categoria</h4>
                  <br />
                  <div class="form-group">
                    <label for="email">Nome</label>
                    <input class="form-control" id="nome" type="text" v-model="nome_categoria" autocomplete="name" />
                  </div>

                  <button @click="cadastrarCategoria()" class="btn btn-primary btn-sm">
                    Cadastrar
                    <i class="fa fa-plus"></i>
                  </button>

                  <button id="cancelar" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#categoria-modal" style="margin-left: 15px">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validate()">Salvar</button>
          <a type="submit" href="/admin/leiloes" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title" style="color: white">
            Arrematação

            <span>Status lote:&nbsp;</span>
            <span style="text-transform: uppercase">
              <span v-if="lote.lote_status == 'ativo'">em leilão</span>
              <span v-if="lote.lote_status == 'vendido'">vendido</span>
              <span v-if="lote.lote_status == 'retirado'">retirado</span>
              <span v-if="lote.lote_status == 'vendido_condicional'">vendido condicional</span>
              <span v-if="lote.lote_status == 'sem_licitante'">sem licitante</span>
              <span v-if="lote.lote_status == 'suspenso'">suspenso</span>
              <span v-if="lote.lote_oculto == 1">(oculto)</span>
            </span>
          </h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="cpf_cnpj">Leilão id</label>
                <input style="text-transform: uppercase" disabled class="form-control" v-model="this.lote.leilao_id" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="comitente">Arrematante</label>

                <select
                  style="text-transform: uppercase"
                  :disabled="!editar"
                  class="custom-select rounded-0"
                  id="comitente"
                  v-model="formData.arrematante_id"
                >
                  <option v-for="hablitacao in habilitados" :key="hablitacao" :value="hablitacao.id">
                    {{ hablitacao.apelido }}
                  </option>
                </select>
              </div>
            </div>
            <!--
            <div class="col-sm-3">
              <div class="form-group">
                <label for="comitente">Lote status</label>

                <select style="text-transform: uppercase;"  :disabled="!editar" class="custom-select rounded-0" id="comitente" v-model="formData.lote_status">
                  <option value="ativo">Ativo</option>
                  <option value="retirado">Retirado</option>
                  <option value="sem_licitante">Sem licitante</option>
                  <option value="suspenso">Suspenso</option>
                  <option value="vendido">Vendido</option>
                  <option value="vendido_condicional">Vendido condicional</option>
                </select>
              </div>
            </div>
            -->
            <div class="col-sm-4">
              <div class="form-group">
                <label for="cpf_cnpj">Praça</label>
                <select
                  v-if="formData.praca != ''"
                  style="text-transform: uppercase"
                  :disabled="!editar"
                  class="custom-select rounded-0"
                  id="arremate_praca"
                  v-model="formData.praca"
                >
                  <option value="1">1º praça</option>
                  <option value="2">2º praça</option>
                  <option value="3">3º praça</option>
                  <option value="4">4º praça</option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <label for="comitente">Data e hora</label>

              <InputMask
                :disabled="!editar"
                class="form-control"
                v-model="formData.data_lance"
                placeholder="__/__/____  00:00"
                mask="99/99/9999 99:99:99"
                slotChar="__/__/____ 00:00"
              />

              <span v-if="editar || errors.data_lance" style="color: red" v-for="error in errors.data_lance">
                {{ error.message }}
              </span>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">Valor R$</label>
                <input :disabled="!editar" @blur="calcularValorArrematacao" class="form-control" v-model="formData.valor_arrematacao_label" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">Forma pagamento {{ formData.forma_pagamento }}</label>
                <select
                  style="text-transform: uppercase"
                  :disabled="!editar"
                  class="custom-select rounded-0"
                  id="comitente"
                  v-model="formData.forma_pagamento"
                >
                  <option :value="0">À VISTA</option>
                  <option :value="1">PARCELADO</option>
                </select>
              </div>

              <span v-if="editar" style="color: red" v-for="error in v$.forma_pagamento.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="endereco_estado">Núm. NF</label>
                <input style="text-transform: uppercase" :disabled="!editar" class="form-control" v-model="formData.lote_nf" />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateDadosArremate()" v-if="editar">Salvar</button>
          <button style="margin-left: 5px; color: white" type="submit" class="btn btn-secondary" @click="validarStatusLote" v-if="!editar">
            Editar
          </button>

          <button
            style="margin-left: 5px; color: white"
            type="submit"
            class="btn btn-danger"
            @click="(editar = false), (formData.editar_dados_lance = false)"
            v-else
          >
            Cancelar
          </button>

          <button
            style="margin-left: 5px; color: white"
            type="submit"
            class="btn btn-danger"
            v-if="lote.lote_lance_user_id != null"
            @click="cancelarLance()"
          >
            Excluir último lance
          </button>

          <button
            style="margin-left: 5px; color: white"
            type="submit"
            class="btn btn-danger"
            v-if="lote.lote_lance_user_id != null"
            @click="cancelarTodosOsLances()"
          >
            Limpar todos os lances
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import currencyController from "../../controller/currencyController";
import auxFormatacao from "../../controller/auxFormatacao";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import Editor from "primevue/editor";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal, currencyController, auxFormatacao],

  props: ["estados", "cidades", "leilao", "processo", "lote", "habilitados", "ultimo_lance"],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      show_categoria_modal: false,
      nome: "",
      isLoading: false,
      my_comitentes: [],
      cadastrar_categoria: false,
      categorias: [],
      label_valor_1: 0,
      label_valor_2: 0,
      label_valor_3: 0,
      label_valor_4: 0,
      percentual_valor_1: 0,
      percentual_valor_2: 0,
      percentual_valor_2: 0,
      percentual_valor_3: 0,
      my_cidades: [],
      editar: false,
      errors: {},
      processos: "",
      lote_valor_1: 0,
      lote_valor_2: 0,
      lote_valor_3: 0,
      lote_valor_4: 0,
    };
  },

  setup() {
    const formData = reactive({
      lote_nf: "",
      processo_id: "",
      processo_numero: "",
      leilao_tipo: "",
      praca: "",
      lote_status: "",
      valor_arrematacao_label: "",
      valor_arrematacao: "",
      leilao_id: "",
      arrematante_id: "",
      data_lance: "",
      forma_pagamento: null,
      lote_numero: 1,
      lote_situacao: "",
      lote_label_color: "",
      lote_label: "",
      lote_tipo: "",
      lote_permitir_parcelamento: "",
      lote_permitir_form_parcelamento: "",
      lote_negar_pf: "",
      lote_texto_parcelamento: "",
      lote_regra_parcelamento: "",
      lote_pct_entrada: "",
      lote_max_parcelas: "",
      lote_indice_correcao: "",
      lote_permitir_form_proposta: "",
      lote_permitir_form_proposta_inferior: "",
      lote_comissao: "",
      lote_comissao_tipo: "lance",
      lote_sucata_restricao: "",
      lote_incrementos: "",
      lote_ids_preferencias: "",
      cidade_id: "",
      estado_id: "",
      categoria_id: "",
      lote_titulo: "",
      lote_descricao: "",
      lote_info_adicional: "",
      lote_avaliacao: "",
      lote_valor_1: "",
      lote_valor_2: "",
      lote_valor_3: "",
      lote_valor_4: "",
      leilao: "",
      lote_icms: "0.9",
      lotes_ids_cliente_lance_pref_prio_maior: "",
      lotes_ids_cliente_lance_pref_prio_media: "",
      lotes_ids_cliente_lance_pref_prio_menor: "",
      editar_dados_lance: false,
    });

    const rules = computed(() => {
      let local_rules = {
        lote_tipo: { required },
        lote_numero: { required },
        lote_permitir_parcelamento: { required },
        lote_permitir_form_proposta: { required },
        lote_comissao: { required },
        lote_comissao_tipo: { required },
        lote_incrementos: { required },
        lote_titulo: { required },
        lote_descricao: { required },
        lote_avaliacao: { required },
        lote_valor_1: { required, valorMinimo: helpers.withMessage(" O valor deve ser maior que zero.", valorMinimo) },
      };

      if (formData.editar_dados_lance) {
        local_rules.data_lance = { required };
        local_rules.forma_pagamento = { required };
      }

      if (formData.leilao.leilao_1_modalidade == "venda") {
        local_rules.lote_permitir_form_proposta_inferior = { required };
      }

      if (formData.lote_tipo == "sucata") {
        local_rules.lote_sucata_restricao = { required };
      }

      if (formData.lote_permitir_parcelamento == 1) {
        local_rules.lote_pct_entrada = { required };
        local_rules.lote_max_parcelas = { required };
        local_rules.lote_indice_correcao = { required };
      }

      if (formData.leilao.leilao_num_pracas >= 2) {
        local_rules.lote_valor_2 = { required, valorMinimo: helpers.withMessage(" O valor deve ser maior que zero.", valorMinimo) };
      }

      if (formData.leilao.leilao_num_pracas >= 3) {
        local_rules.lote_valor_3 = { required, valorMinimo: helpers.withMessage(" O valor deve ser maior que zero.", valorMinimo) };
      }

      if (formData.leilao.leilao_num_pracas >= 4) {
        local_rules.lote_valor_4 = { required, valorMinimo: helpers.withMessage(" O valor deve ser maior que zero.", valorMinimo) };
      }

      if (formData.lote_tipo == "movel" || formData.lote_sucata_restricao == 1) {
        local_rules.lote_icms = { required };
      }

      if (formData.leilao.leilao_1_modalidade == "venda") {
        local_rules.lote_permitir_form_proposta_inferior = { required };
      }

      /*
      if (formData.leilao_tipo == "judicial") {
        local_rules.processo = { required };
      }
        */

      return local_rules;
    });

    const valorMinimo = (valor) => {
      if (!valor || valor <= 0) {
        return false;
      } else {
        return true;
      }
    };

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.toCurrency(undefined);

    console.log("LOTE");
    console.log(this.ultimo_lance);
    console.log(this.lote);
    console.log(this.leilao);

    this.formData.leilao_tipo = this.leilao.leilao_tipo;
    this.formData.leilao = this.leilao;
    this.my_cidades = this.cidades;

    this.formData.praca = this.lote.lote_lance_praca;
    this.formData.lote_status = this.lote.lote_status;
    this.formData.leilao_id = this.lote.leilao_id;
    this.formData.arrematante_id = this.lote.lote_lance_user_id;
    this.formData.data_lance = this.formatDate(this.lote.lote_lance_data);
    this.formData.lote_nf = this.lote.lote_nf;
    this.formData.forma_pagamento = this.lote.lote_ultimo_lance_parcelado;
    this.formData.valor_arrematacao_label = this.toCurrency(this.lote.lote_lance);
    this.formData.valor_arrematacao = this.lote.lote_lance;

    this.formData.lote_situacao = this.lote.lote_situacao;
    this.formData.lote_label_color = this.lote.lote_label_color;
    this.formData.lote_label = this.lote.lote_label;
    this.formData.lote_tipo = this.lote.lote_tipo;
    this.formData.lote_permitir_parcelamento = this.lote.lote_permitir_parcelamento;
    this.formData.lote_texto_parcelamento = this.lote.lote_texto_parcelamento;
    this.formData.lote_regra_parcelamento = this.lote.lote_regra_parcelamento;
    this.formData.lote_pct_entrada = this.lote.lote_pct_entrada;
    this.formData.lote_max_parcelas = this.lote.lote_max_parcelas;
    this.formData.lote_indice_correcao = this.lote.lote_indice_correcao;
    this.formData.lote_permitir_form_proposta = this.lote.lote_permitir_form_proposta;
    this.formData.lote_permitir_form_proposta_inferior = this.lote.lote_permitir_form_proposta_inferior;
    this.formData.lote_comissao = this.formatar02CasaDecimal(this.lote.lote_comissao);
    this.formData.lote_comissao_tipo = this.lote.lote_comissao_tipo;
    this.formData.lote_sucata_restricao = this.lote.lote_sucata_restricao;
    this.formData.lote_incrementos = this.lote.lote_incrementos;
    this.formData.lote_ids_preferencias = this.lote.lote_ids_preferencias;
    this.formData.cidade_id = this.lote.cidade_id;
    this.formData.estado_id = this.lote.estado_id;
    this.formData.categoria = this.lote.categoria;
    this.formData.lote_titulo = this.lote.lote_titulo;
    this.formData.lote_descricao = this.lote.lote_descricao;
    this.formData.lote_info_adicional = this.lote.lote_info_adicional;
    this.formData.lote_valor_1 = this.lote.lote_valor_1;
    this.formData.lote_valor_2 = this.lote.lote_valor_2;
    this.formData.lote_valor_3 = this.lote.lote_valor_3;
    this.formData.lote_valor_4 = this.lote.lote_valor_4;
    this.formData.categoria_id = this.lote.categoria_id;
    this.formData.lote_icms = this.lote.lote_icms;
    this.formData.lotes_ids_cliente_lance_pref_prio_maior = this.lote.lotes_ids_cliente_lance_pref_prio_maior;
    this.formData.lotes_ids_cliente_lance_pref_prio_media = this.lote.lotes_ids_cliente_lance_pref_prio_media;
    this.formData.lotes_ids_cliente_lance_pref_prio_menor = this.lote.lotes_ids_cliente_lance_pref_prio_menor;

    if (this.lote.lote_avaliacao) {
      this.formData.lote_avaliacao = this.toCurrency(this.lote.lote_avaliacao);
    }

    this.buscarCategorias();

    this.formData.processo_id = this.lote.processo_id;
    this.formData.processo_numero = this.processo.processo_numero;
    //this.buscarProcessos();
  },

  methods: {
    cancelarTodosOsLances() {
      let html = "Tem certeza que deseja cancelar limpar todos os lances deste lote?";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          input: "textarea",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero excluir!",
          focusConfirm: false,
          preConfirm: (value) => {
            if (!value) {
              this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> O motivo é obrigatório.');
            }
          },
        })
        .then((result) => {
          let data = {
            lote_id: this.lote.id,
            lance_id: this.ultimo_lance.id,
            motivo_cancelamento: result.value,
            pergunta: html,
          };

          console.log(data);

          axios
            .post(`/admin/lance/cancelar_todos_os_lances`, data)
            .then((response) => {
              this.isLoading = false;

              if (response.data.success) {
                this.showSuccessMessageWithButtonAndReload("Sucesso", response.data.message);
              } else {
                this.showErrorMessageWithButtonAndReload("Ops...", response.data.message);
              }
            })
            .catch((error) => {
              this.showErrorMessageWithButton("Ops..", error);
              console.log(error);
            });
        });
    },

    cancelarLance() {
      /*
Tem certeza que deseja cancelar o lance ID 2722,
do usuário com apelido GLAUBERV, no valor de R$ 104,00
enviado na data de 19/07/2025 às 11:52:15 ?
      */

      let html =
        "Tem certeza que deseja cancelar o lance com ID " +
        this.ultimo_lance.id +
        ", do usuário " +
        (this.ultimo_lance.user.profile.cadastro_tipo == "pj"
          ? this.ultimo_lance.user.profile.pj_razao_social
          : this.ultimo_lance.user.profile.nome_completo) +
        " com apelido " +
        this.ultimo_lance.user.apelido +
        ", no valor de R$" +
        this.toCurrency(this.ultimo_lance.valor) +
        " enviado na data " +
        this.formatDateOnly(this.ultimo_lance.created_at) +
        " às " +
        this.formatTimeOnly(this.ultimo_lance.created_at) +
        "?";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          input: "textarea",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero excluir!",
          focusConfirm: false,
          preConfirm: (value) => {
            if (!value) {
              this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> O motivo é obrigatório.');
            }
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            let data = {
              lote_id: this.lote.id,
              lance_id: this.ultimo_lance.id,
              motivo_cancelamento: result.value,
              pergunta: html,
            };

            console.log(data);

            axios
              .post(`/admin/lance/cancelar_lance`, data)
              .then((response) => {
                this.isLoading = false;

                if (response.data.success) {
                  this.showSuccessMessageWithButtonAndReload("Sucesso", response.data.message);
                } else {
                  this.showErrorMessageWithButtonAndReload("Ops...", response.data.message);
                }
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          }
        });
    },

    alterarValor() {
      this.lote_valor_1 = Number(this.toNumber(this.label_valor_1));
      this.lote_valor_2 = Number(this.toNumber(this.label_valor_2));
      this.lote_valor_3 = Number(this.toNumber(this.label_valor_3));
      this.lote_valor_4 = Number(this.toNumber(this.label_valor_4));
    },

    formatarValor() {
      if (this.lote_valor_1 > 0) {
        this.label_valor_1.valor = this.toCurrency(this.formData.lote_valor_1);
      }
      if (this.lote_valor_2 > 0) {
        this.label_valor_2.valor = this.toCurrency(this.formData.lote_valor_2);
      }
      if (this.lote_valor_3 > 0) {
        this.label_valor_3.valor = this.toCurrency(this.formData.lote_valor_3);
      }
      if (this.lote_valor_4 > 0) {
        this.label_valor_4.valor = this.toCurrency(this.formData.lote_valor_4);
      }
    },

    buscarProcessos() {
      let data = {
        inicio: 0,
        tamanho: 10000,
      };

      if (this.formData.cidade_id) {
        data.cidade_id = this.formData.cidade_id;
      }

      if (this.formData.estado_id) {
        data.estado_id = this.formData.estado_id;
      }

      console.log("Buscando processos");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          console.log("Processos");
          console.log(response.data.processos);
          this.processos = response.data.processos;

          //ATRIBUINDO PROCESSO
          if (this.lote.processo_id) {
            let indice = this.processos.findIndex((element) => element["id"] == this.lote.processo_id);

            if (indice >= 0) {
              this.formData.processo = this.processos[indice];
            } else {
              this.formData.processo = null;
            }
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    calcularValorArrematacao() {
      let avaliacao = this.formData.valor_arrematacao_label;

      if (typeof avaliacao !== "number") {
        avaliacao = this.toNumber(avaliacao);

        console.log("Arrematação em number");
        console.log(avaliacao);
      }

      this.formData.valor_arrematacao_label = this.toCurrency(avaliacao);
      this.formData.valor_arrematacao = avaliacao;
    },

    async validateDadosArremate() {
      if (this.editar) {
        const result = await this.v$.$validate();
        if (result) {
          let valid = true;

          if (moment(this.formData.data_lance, "DD/MM/yyyy").format("yyyy-MM-DD") == "Invalid date") {
            this.errors.data_lance = [{ message: "Digite uma data válida." }];

            valid = false;
          } else {
            this.errors.data_lance = [];
          }

          if (valid) {
            let data = {
              lote_id: this.lote.id,
              lote_lance_user_id: this.formData.arrematante_id,
              lote_lance_data: this.formatDateToSave(this.formData.data_lance),
              lote_lance: this.formData.valor_arrematacao,
              praca: this.formData.praca,
              lote_status: this.formData.lote_status,
              lote_ultimo_lance_parcelado: this.formData.forma_pagamento,
              lote_nf: this.formData.lote_nf,
            };

            console.log("Enviando");
            console.log(data);

            axios
              .post(`/admin/lote/update/dados_arremate`, data)
              .then((response) => {
                if (response.data.success) {
                  this.showSuccessMessageWithButton("Sucesso", "Dados atualizados");
                  this.editar = false;
                  this.formData.editar_dados_lance = false;
                } else {
                  this.showErrorMessageWithButton("Ops...", response.data.msg);
                }
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          }
        } else {
          console.log(this.v$);
        }
      }
    },

    validarStatusLote() {
      let data = {
        lote_id: this.lote.id,
      };

      axios
        .post(`/admin/lote/validar_status`, data)
        .then((response) => {
          if (response.data.success) {
            this.editar = true;
            this.formData.editar_dados_lance = true;
          } else {
            this.editar = false;
            this.formData.editar_dados_lance = false;
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    formatDateOnly(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatTimeOnly(date) {
      return moment(date).format("HH:mm:ss");
    },

    upper(field_name) {
      console.log(field_name);
      this.formData[field_name] = this.formData[field_name].toUpperCase();
      console.log(this.formData[field_name]);
    },

    alterarIcms() {
      if (this.formData.lote_tipo == "movel" || this.formData.lote_sucata_restricao == 1) {
        this.formData.lote_icms = 0.9;
      } else {
        this.formData.lote_icms = null;
      }
    },

    changeTipoLote() {
      if (this.formData.lote_tipo == "sucata") {
        this.formData.lote_sucata_restricao = 1;
      } else {
        this.formData.lote_sucata_restricao = 0;
      }

      this.alterarIcms();
    },

    zerarNovosValores() {
      this.label_valor_1 = 0;
      this.label_valor_2 = 0;
      this.label_valor_3 = 0;
      this.label_valor_4 = 0;

      this.lote_valor_1 = 0;
      this.lote_valor_2 = 0;
      this.lote_valor_3 = 0;
      this.lote_valor_4 = 0;
    },

    changeParcelamento() {
      if (this.formData.lote_permitir_parcelamento == 0) {
        this.formData.lote_texto_parcelamento = null;
        this.formData.lote_regra_parcelamento = null;
        this.formData.lote_pct_entrada = null;
        this.formData.lote_max_parcelas = null;
        this.formData.lote_indice_correcao = null;
      } else {
        this.formData.lote_pct_entrada = "25";
        this.formData.lote_indice_correcao = "TJ/PR (INPC/IGPDI)";
        this.formData.lote_max_parcelas = 30;
      }
    },

    cadastrarCategoria() {
      if (!this.nome_categoria) {
        this.showErrorMessageWithButton("Ops..", "O campo nome é obrigatório");
      } else {
        let data = {
          nome: this.nome_categoria,
        };

        axios
          .post(`/admin/categoria/store`, data)
          .then((response) => {
            this.showSuccessMessageWithButton("Sucesso", "Categoria cadastrada");
            document.getElementById("cancelar").click();

            axios
              .post(`/admin/categorias/list`)
              .then((response) => {
                this.categorias = response.data.categorias;
                this.formData.categoria_id = response.data.last_categoria.id;
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },

    buscarCategorias() {
      axios
        .post(`/admin/categorias/list`)
        .then((response) => {
          this.categorias = response.data.categorias;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    calcular() {
      let avaliacao = this.formData.lote_avaliacao;

      if (typeof avaliacao !== "number") {
        avaliacao = this.toNumber(avaliacao);

        console.log("Avaliação em number");
        console.log(avaliacao);
      }

      this.label_valor_1 = this.toCurrency((this.percentual_valor_1 * avaliacao) / 100);
      this.label_valor_2 = this.toCurrency((this.percentual_valor_2 * avaliacao) / 100);
      this.label_valor_3 = this.toCurrency((this.percentual_valor_3 * avaliacao) / 100);
      this.label_valor_4 = this.toCurrency((this.percentual_valor_4 * avaliacao) / 100);

      this.alterarValor();
    },

    importar() {
      let avaliacao = this.formData.lote_avaliacao;

      if (typeof avaliacao !== "number") {
        avaliacao = this.toNumber(avaliacao);
      }

      this.formData.lote_valor_1 = this.lote_valor_1;
      this.formData.lote_valor_2 = this.lote_valor_2;
      this.formData.lote_valor_3 = this.lote_valor_3;
      this.formData.lote_valor_4 = this.lote_valor_4;

      this.formData.lote_avaliacao = this.toCurrency(this.formData.lote_avaliacao);
    },

    addIncrementos(value) {
      if (!this.formData.lote_incrementos.includes(value)) {
        if (this.formData.lote_incrementos != "") {
          this.formData.lote_incrementos += ";";
        }

        this.formData.lote_incrementos += value;
      }
    },

    addIndiceCorrecao(value) {
      if (!this.formData.lote_indice_correcao.includes(value)) {
        if (this.formData.lote_indice_correcao != "") {
          this.formData.lote_indice_correcao += ";";
        }

        this.formData.lote_indice_correcao += value;
      }
    },

    async validate() {
      const result = await this.v$.$validate();
      if (result) {
        this.create();
      } else {
        console.log(this.v$);
      }
    },

    buscarComitenteCadastrado(comitente_id) {
      let data = {
        comitente_id: comitente_id,
      };

      this.cadastrar_comitente = false;

      axios
        .post(`/admin/comitente/search_all`, data)
        .then((response) => {
          this.my_comitentes = response.data.comitentes;

          this.formData.comitente = this.my_comitentes[this.my_comitentes.length - 1];
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    //FORMATA A DATA PARA ENVIAR PARA O BANCO (De DD-MM-yyyy HH:mm:ss Para yyyy-MM-DD HH:mm:ss )
    formatSelectedDate3(date) {
      return moment(date, "DD-MM-yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    create() {
      this.isLoading = true;

      if (this.formData.leilao.leilao_num_pracas < 4) {
        this.formData.lote_valor_4 = 0.0;
      }

      if (this.formData.leilao.leilao_num_pracas < 3) {
        this.formData.lote_valor_3 = 0.0;
      }

      if (this.formData.leilao.leilao_num_pracas < 2) {
        this.formData.lote_valor_2 = 0.0;
      }

      let avaliacao = this.formData.lote_avaliacao.replaceAll(".", "");
      avaliacao = avaliacao.replaceAll(",", ".");

      let data = {
        lote_id: this.lote.id,
        leilao_id: this.leilao.id,
        categoria_id: this.formData.categoria_id,
        lote_situacao: this.formData.lote_situacao,
        lote_label_color: this.formData.lote_label_color,
        lote_label: this.formData.lote_label,
        lote_tipo: this.formData.lote_tipo,
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
        lote_permitir_parcelamento: this.formData.lote_permitir_parcelamento,
        lote_texto_parcelamento: this.formData.lote_texto_parcelamento,
        lote_regra_parcelamento: this.formData.lote_regra_parcelamento,
        lote_pct_entrada: this.formData.lote_pct_entrada,
        lote_max_parcelas: this.formData.lote_max_parcelas,
        lote_indice_correcao: this.formData.lote_indice_correcao,
        lote_permitir_form_proposta: this.formData.lote_permitir_form_proposta,
        lote_permitir_form_proposta_inferior: this.formData.lote_permitir_form_proposta_inferior,
        lote_comissao: this.formData.lote_comissao,
        lote_comissao_tipo: this.formData.lote_comissao_tipo,
        lote_sucata_restricao: this.formData.lote_sucata_restricao,
        lote_incrementos: this.formData.lote_incrementos,
        lote_ids_preferencias: this.formData.lote_ids_preferencias,
        lote_titulo: this.formData.lote_titulo,
        lote_descricao: this.formData.lote_descricao,
        lote_info_adicional: this.formData.lote_info_adicional,
        lote_avaliacao: avaliacao,
        lote_valor_1: this.formData.lote_valor_1,
        lote_valor_2: this.formData.lote_valor_2,
        lote_valor_3: this.formData.lote_valor_3,
        lote_valor_4: this.formData.lote_valor_4,
        lotes_ids_cliente_lance_pref_prio_maior: this.formData.lotes_ids_cliente_lance_pref_prio_maior,
        lotes_ids_cliente_lance_pref_prio_media: this.formData.lotes_ids_cliente_lance_pref_prio_media,
        lotes_ids_cliente_lance_pref_prio_menor: this.formData.lotes_ids_cliente_lance_pref_prio_menor,
      };

      if (this.leilao.processo_id) {
        data.processo_id = this.formData.processo_id;
      }

      if (this.formData.lote_tipo == "movel" || this.formData.lote_sucata_restricao == 1) {
        data.lote_icms = this.formData.lote_icms;
      } else {
        data.lote_icms = null;
      }

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/lote/update`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.forceDisconnect();

            this.showSuccessMessageWithButtonAndCallback("Sucesso", "Dados atualizados", () => {
              this.showLotesBtnsOptions(this.leilao.id);
            });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);

          this.isLoading = false;
        });
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("DESCONECTANDO!!");

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    formatar() {
      if (this.formData.lotes_ids_cliente_lance_pref_prio_maior) {
        this.formData.lotes_ids_cliente_lance_pref_prio_maior = this.replaceAll(
          this.formData.lotes_ids_cliente_lance_pref_prio_maior.trim(),
          " ",
          ""
        );

        this.formData.lotes_ids_cliente_lance_pref_prio_maior = this.formData.lotes_ids_cliente_lance_pref_prio_maior.replace(/[^\d;]/g, "");
      }

      if (this.formData.lotes_ids_cliente_lance_pref_prio_media) {
        this.formData.lotes_ids_cliente_lance_pref_prio_media = this.replaceAll(
          this.formData.lotes_ids_cliente_lance_pref_prio_media.trim(),
          " ",
          ""
        );

        this.formData.lotes_ids_cliente_lance_pref_prio_media = this.formData.lotes_ids_cliente_lance_pref_prio_media.replace(/[^\d;]/g, "");
      }

      if (this.formData.lotes_ids_cliente_lance_pref_prio_menor) {
        this.formData.lotes_ids_cliente_lance_pref_prio_menor = this.replaceAll(
          this.formData.lotes_ids_cliente_lance_pref_prio_menor.trim(),
          " ",
          ""
        );

        this.formData.lotes_ids_cliente_lance_pref_prio_menor = this.formData.lotes_ids_cliente_lance_pref_prio_menor.replace(/[^\d;]/g, "");
      }
    },

    buscarCidades() {
      this.isLoading = true;

      this.formData.processo = null;

      let data = {
        estado_id: this.formData.estado_id,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          this.formData.cidade_id = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>
